"use client";
import {
  useComposite
} from "../__chunks/7PHIY4AC.js";
import "../__chunks/6QXBPV75.js";
import {
  useToolbarStore
} from "../__chunks/DLGO5RXE.js";
import "../__chunks/VUP7S67H.js";
import "../__chunks/7GWB36ES.js";
import {
  ToolbarScopedContextProvider,
  useToolbarProviderContext
} from "../__chunks/RGE4LYC4.js";
import "../__chunks/X3ATWMYX.js";
import "../__chunks/KSMDNUGB.js";
import "../__chunks/HJIEYVEO.js";
import "../__chunks/SHA3WOPI.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/2ID5JPOO.js";
import {
  useWrapElement
} from "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/toolbar/toolbar.tsx
import { jsx } from "react/jsx-runtime";
var useToolbar = createHook(
  (_a) => {
    var _b = _a, {
      store: storeProp,
      orientation: orientationProp,
      virtualFocus,
      focusLoop,
      rtl
    } = _b, props = __objRest(_b, [
      "store",
      "orientation",
      "virtualFocus",
      "focusLoop",
      "rtl"
    ]);
    const context = useToolbarProviderContext();
    storeProp = storeProp || context;
    const store = useToolbarStore({
      store: storeProp,
      orientation: orientationProp,
      virtualFocus,
      focusLoop,
      rtl
    });
    const orientation = store.useState(
      (state) => state.orientation === "both" ? void 0 : state.orientation
    );
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(ToolbarScopedContextProvider, { value: store, children: element }),
      [store]
    );
    props = __spreadValues({
      role: "toolbar",
      "aria-orientation": orientation
    }, props);
    props = useComposite(__spreadValues({ store }, props));
    return props;
  }
);
var Toolbar = createComponent((props) => {
  const htmlProps = useToolbar(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Toolbar.displayName = "Toolbar";
}
export {
  Toolbar,
  useToolbar
};
